module.exports = __webpack_public_path__ + "img/website-banner.ee4fe1b3.jpg";